@if (loading) {
<div class="loading">
  <mat-spinner [diameter]="40"></mat-spinner>
</div>
}@else if(!user_payment_intent){
<div class="empty">
  <h1>Failed to query the payment result</h1>
  <p>Please try again later.</p>
</div>
}@else if(isSuccessed){
<div class="successed">
  <app-logo [size]="100"></app-logo>
  <h1>Thank you for your purchase</h1>
  <p>
    Your order has been successfully placed. We’ll send you a confirmation email
    shortly.
  </p>
  <p class="contact">If you have any questions, please contact us.</p>

  <div class="actions">
    <a matButton="filled" routerLink="/account/orders">View Your Order</a>
    <a matButton routerLink="/search" aria-label="Continue Shopping"
      >Continue Shopping</a
    >
  </div>
</div>
}@else if(isPending){
<div class="pending">
  <mat-icon fontSet="material-symbols-outlined">pending</mat-icon>
  <h1>Your Payment is In Progress</h1>
  <p>Please wait for the payment to complete.</p>
  <div class="actions">
    <a matButton="filled" (click)="confirmPaymentIntent()">Refresh</a>
    <a matButton routerLink="/search" aria-label="Continue Shopping"
      >Continue Shopping</a
    >
  </div>
</div>
}@else{
<div class="failed">
  <mat-icon fontSet="material-symbols-outlined">error</mat-icon>
  <h1>Payment Failed</h1>
  <p>Your payment has failed. Please try again or contact us.</p>
  <div class="actions">
    <a matButton routerLink="/search" aria-label="Continue Shopping"
      >Continue Shopping</a
    >
  </div>
</div>
}
